import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {useEffect, useState} from "react"
import {useDispatch, useSelector} from "react-redux";
import Typography from "@mui/material/Typography";
import {clear, setAlertBody, setAlertHeader} from "../features/AlertSlice";

const useAlertMessage = () => {
    const dispatch = useDispatch()
    function set(header, body) {
        dispatch(setAlertHeader(header));
        dispatch(setAlertBody(body));
    }
    return set
}


const AlertMessage = () => {
    const [showModal, setShowModal] = useState(false);
    const alertBody = useSelector(state => state.alert.body)
    const alertHeader = useSelector(state => state.alert.header)
    const dispatch = useDispatch()
    useEffect(() => {
        if(alertBody && alertHeader) {
            setShowModal(true)
        }
        else{
            setShowModal(false);
        }
    }, [alertBody, alertHeader])


    return <Dialog
        open={showModal}
        onClose={() => { setShowModal(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth
    >
        <DialogTitle id="alert-dialog-title">
            {alertHeader}
        </DialogTitle>
        <DialogContent>
            <DialogContentText component={'span'} id="alert-dialog-description">
                <Typography>{alertBody}</Typography>
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => {dispatch(clear())}} color={'info'} variant={'contained'} autoFocus>
                ОК
            </Button>
        </DialogActions>
    </Dialog>
}
export {useAlertMessage}
export default AlertMessage;